
export const ASSET_CONFIRM_EMPTY = 'ASSET_CONFIRM_EMPTY'
export const ASSET_CONFIRM_GET_DATA = 'ASSET_CONFIRM_GET_DATA'
export const ASSET_CONFIRM_GET_DATA_SUCCESS = 'ASSET_CONFIRM_GET_DATA_SUCCESS'
export const ASSET_CONFIRM_GET_DATA_FAILURE = 'ASSET_CONFIRM_GET_DATA_FAILURE '

export const ASSET_CONFIRM_EDIT = 'ASSET_CONFIRM_EDIT'
export const ASSET_CONFIRM_EDIT_SUCCESS = 'ASSET_CONFIRM_EDIT_SUCCESS'
export const ASSET_CONFIRM_EDIT_FAILURE = 'ASSET_CONFIRM_EDIT_FAILURE'

export const ASSET_CONFIRM_DELETE = 'ASSET_CONFIRM_DELETE'
export const ASSET_CONFIRM_DELETE_SUCCESS = 'ASSET_CONFIRM_DELETE_SUCCESS'
export const ASSET_CONFIRM_DELETE_FAILURE = 'ASSET_CONFIRM_DELETE_FAILURE'

export const ASSET_CONFIRM_EXISTS_SUCCESS = 'ASSET_CONFIRM_EXISTS_SUCCESS'
export const ASSET_CONFIRM_EXISTS_FAILURE = 'ASSET_CONFIRM_EXISTS_FAILURE'

export const ASSET_CONFIRM_ADD_TAGS = 'ASSET_CONFIRM_ADD_TAGS'
export const ASSET_CONFIRM_CHANGE_NAME = 'ASSET_CONFIRM_CHANGE_NAME'
export const ASSET_CONFIRM_CHANGE_COPYRIGHT = 'ASSET_CONFIRM_CHANGE_COPYRIGHT'

export const ASSET_CONFIRM_MOVE_FOLDER = 'ASSET_CONFIRM_MOVE_FOLDER'
export const ASSET_CONFIRM_MOVE_FOLDER_SUCCESS = 'ASSET_CONFIRM_MOVE_FOLDER_SUCCESS'
export const ASSET_CONFIRM_MOVE_FOLDER_FAILURE = 'ASSET_CONFIRM_MOVE_FOLDER_FAILURE'

export const ASSET_CONFIRM_UPDATE_FROM_PERMISSION = 'ASSET_CONFIRM_UPDATE_FROM_PERMISSION'

export const ASSET_BY_CONFIRM = 'ASSET_BY_CONFIRM'